import React, { useState, useEffect, useRef } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Tooltip from '@material-ui/core/Tooltip';

function TruncateItemWithTooltip({ option }: { option: any }) {
  const classes = useStyles();
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(true);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [option.displayName || option]);

  const displayText = option.displayName || option.name || option;

  const content = (
    <span ref={textRef} className={classes.truncate}>
      {displayText}
    </span>
  );

  return isTruncated && displayText ? (
    <Tooltip title={displayText} placement="top" arrow>
      {content}
    </Tooltip>
  ) : (
    content
  );
}

export default TruncateItemWithTooltip;

const useStyles = makeStyles(() => ({
  truncate: {
    display: 'inline-block',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    verticalAlign: 'middle',
  },
}));
